
$(document).on("click", ".hk-element-variant", function(e) {
$('.hk-element-variant').removeClass('hk-active');
$(this).addClass('hk-active');
var variant_id = $(this).attr('variant_id');
var selling_plan = $(this).attr('selling_plan');
$('.hk-variant-trigger').hide().removeClass('hk-active');
$('.hk-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('hk-active');
$('.hk-checkout-button').attr('variant_id',variant_id);
$('.hk-checkout-button:not(.otp-hk-button)').attr('selling_plan',selling_plan);
});



$(document).on("click", ".hk-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.hk-question').removeClass('active');
    jQuery('.hk-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});

